import pick from 'lodash/pick';
import {
  createStripeAccount,
  updateStripeAccount,
  fetchStripeAccount,
} from '../../ducks/stripeConnectAccount.duck';
import { currentUserShowSuccess, fetchCurrentUser } from '../../ducks/user.duck';
import {
  REQUEST_GROUP_TEMPLATE_ID,
  STRIPE_ONBOARDING_RETURN_URL_SUCCESS,
  STRIPE_VERIFICATION_ACCEPTED_TEMPLATE_ID,
  STRIPE_VERIFICATION_DENIED_TEMPLATE_ID,
  STRIPE_VERIFICATION_LIMIT_REACHED_ADMIN_TEMPLATE_ID,
  STRIPE_VERIFICATION_LIMIT_REACHED_TEMPLATE_ID,
  USER_TYPE_RESTRICTED,
  USER_TYPE_VERIFIED,
} from '../../util/types';
import { updateProfile, updateUserInAlgolia } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { denormalisedResponseEntities, getStripeVerificationStatus } from '../../util/data';
import { onSingleMailApiCollection, updateUserApi, fetchFreeTransactions, createStripeTransfer, fetchTransactionApi,  updateUserStripeConnectionApi } from '../../util/api';

import { storableError } from "../../util/errors";
import { parse } from "../../util/urlHelpers";

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/StripePayoutPage/SET_INITIAL_VALUES';
export const SAVE_PAYOUT_DETAILS_REQUEST = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_REQUEST';
export const SAVE_PAYOUT_DETAILS_SUCCESS = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_SUCCESS';
export const SAVE_PAYOUT_DETAILS_ERROR = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_ERROR';

export const FETCH_TRANSACTIONS_REQUEST = 'app/StripePayoutPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/StripePayoutPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/StripePayoutPage/FETCH_TRANSACTIONS_ERROR';

export const UPDATE_TRANSACTION_REQUEST = 'app/StripePayoutPage/UPDATE_TRANSACTION_REQUEST';
export const UPDATE_TRANSACTION_SUCCESS = 'app/StripePayoutPage/UPDATE_TRANSACTION_SUCCESS';
export const UPDATE_TRANSACTION_ERROR = 'app/StripePayoutPage/UPDATE_TRANSACTION_ERROR';

export const FETCH_TRANSACTION_REQUEST = 'app/StripePayoutPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/StripePayoutPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/StripePayoutPage/FETCH_TRANSACTION_ERROR';


const FREE_TRANSACTION_PER_PAGE = 10;

// ================ Reducer ================ //

const initialState = {
  payoutDetailsSaveInProgress: false,
  payoutDetailsSaved: false,
  fromReturnURL: false,
  transactions: [],
  pagination: null,
  fetchTransactionsError: null,
  updateTransactionError: null,
  transactionInProgress: false,
  updateTransactionProgress: false,
  fetchTransactionProgress: false,
  fetchTransactionError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SAVE_PAYOUT_DETAILS_REQUEST:
      return { ...state, payoutDetailsSaveInProgress: true };
    case SAVE_PAYOUT_DETAILS_ERROR:
      return { ...state, payoutDetailsSaveInProgress: false };
    case SAVE_PAYOUT_DETAILS_SUCCESS:
      return { ...state, payoutDetailsSaveInProgress: false, payoutDetailsSaved: true };

    case FETCH_TRANSACTIONS_REQUEST:
      return {
        ...state,
        transactionInProgress: true,
        fetchTransactionsError: null,
      };

    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactionInProgress: false,
        transactions: payload.data,
        pagination: payload.pagination,
      };

    case FETCH_TRANSACTIONS_ERROR:
      return {
        ...state,
        transactionInProgress: false,
        fetchTransactionsError: payload,
      };

    case UPDATE_TRANSACTION_REQUEST:
      return {
        ...state,
        updateTransactionProgress: payload,
        updateTransactionError: null,
      };

    case UPDATE_TRANSACTION_SUCCESS:
      return {
        ...state,
        updateTransactionProgress: false,
        transactions: state.transactions.map(tx =>
          tx._id === payload._id ? payload : tx
        ),
      };

    case UPDATE_TRANSACTION_ERROR:
      return {
        ...state,
        updateTransactionProgress: false,
        updateTransactionError: payload,
      };

    case FETCH_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchTransactionProgress: payload,
        fetchTransactionError: null,
      };

    case FETCH_TRANSACTION_SUCCESS:
      return {
        ...state,
        fetchTransactionProgress: false,
        transactions: state.transactions.map(tx =>
          tx._id === payload._id ? payload : tx
        ),
      };

    case FETCH_TRANSACTION_ERROR:
      return {
        ...state,
        fetchTransactionProgress: false,
        fetchTransactionError: payload,
      };


    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const savePayoutDetailsRequest = () => ({
  type: SAVE_PAYOUT_DETAILS_REQUEST,
});
export const savePayoutDetailsError = () => ({
  type: SAVE_PAYOUT_DETAILS_ERROR,
});
export const savePayoutDetailsSuccess = () => ({
  type: SAVE_PAYOUT_DETAILS_SUCCESS,
});


// Action Creators
export const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
export const fetchTransactionsSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response
});
export const fetchTransactionsError = error => ({
  type: FETCH_TRANSACTIONS_ERROR,
  payload: error
});

export const updateTransactionRequest = (payload) => ({ type: UPDATE_TRANSACTION_REQUEST, payload });
export const updateTransactionSuccess = transaction => ({
  type: UPDATE_TRANSACTION_SUCCESS,
  payload: transaction
});
export const updateTransactionError = error => ({
  type: UPDATE_TRANSACTION_ERROR,
  payload: error
});

export const fetchTransactionRequest = (payload) => ({ type: FETCH_TRANSACTION_REQUEST, payload });
export const fetchTransactionSuccess = transaction => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: transaction
});
export const fetchTransactionError = error => ({
  type: FETCH_TRANSACTION_ERROR,
  payload: error
});


// ================ Thunks ================ //
export const fetchTransactions = params => async (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsRequest());
  try {
    console.log(params, "params")
    const {
      pageParams,
      payload
    } = params;
    const response = await fetchFreeTransactions({
      payload,
      pageParams
    });
    dispatch(fetchTransactionsSuccess(response));
    return response;
  } catch (error) {
    const errorMessage = storableError(error)
    dispatch(fetchTransactionsError(errorMessage));
    throw error;
  }
};

export const updateTransaction = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(updateTransactionRequest(params.tx_id));
    return createStripeTransfer(params)
      .then((response) => {
        dispatch(updateTransactionSuccess(response.data));
        return response;
      })
      .catch(error => {
        console.log(error, '&&& &&& => e');
        const errorMessage = storableError(error)
        dispatch(updateTransactionError(errorMessage));
        return errorMessage;
      })
  } catch (error) {
    console.log(error, '&&& &&& => error');
    const errorMessage = storableError(error)
    dispatch(updateTransactionError(errorMessage));
    return errorMessage;
  }
};

export const fetchTransaction = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(fetchTransactionRequest(params.tx_id));
    return fetchTransactionApi(params)
      .then((response) => {
        dispatch(fetchTransactionSuccess(response.data));
        return response;
      })
      .catch(error => {
        console.log(error, '&&& &&& => e');
        const errorMessage = storableError(error)
        dispatch(fetchTransactionError(errorMessage));
        return errorMessage;
      })
  } catch (error) {
    console.log(error, '&&& &&& => error');
    const errorMessage = storableError(error)
    dispatch(fetchTransactionError(errorMessage));
    return errorMessage;
  }
};


export const savePayoutDetails = (values, isUpdateCall) => (dispatch, getState, sdk) => {
  const upsertThunk = isUpdateCall ? updateStripeAccount : createStripeAccount;
  dispatch(savePayoutDetailsRequest());

  return dispatch(upsertThunk(values, { expand: true }))
    .then(response => {
      dispatch(savePayoutDetailsSuccess());
      return response;
    })
    .catch(() => dispatch(savePayoutDetailsError()));
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { returnURLType } = params || {};
  // Clear state so that previously loaded data is not visible
  // in case this page load fails.
  dispatch(setInitialValues());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  const queryParams = parse(search);
  const { page = 1 } = queryParams;

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(response => {
    const currentUser = getState().user.currentUser;
    const { stripeAccount, attributes, id } = currentUser || {};
    console.log('&&& Stripe payout page &&& => loadData');

    dispatch(fetchTransactions(
      {
        payload: {
          provider_id: currentUser?.id?.uuid
        },
        pageParams: {
          page,
          perPage: FREE_TRANSACTION_PER_PAGE
        }
      }));

    if (currentUser && stripeAccount) {
      console.log('&&& Stripe currentUser.stripeAccount &&& => loadData');
      // fetch stripe account of user
      dispatch(fetchStripeAccount());

      const { profile, email } = attributes || {};
      const { firstName, lastName, metadata } = profile || {};
      const { verification_attempts = 0, id_verification_status, manual_override_reason = null } =
        metadata || {};
      const current_verification_attempts = verification_attempts + 1;

      // Verify Badge of User When Added the Submit Form.
      if (
        returnURLType &&
        id_verification_status !== USER_TYPE_VERIFIED &&
        current_verification_attempts <= 4
      ) {
        console.log('&&& Verify Badge of User When Added the Submit Form. &&& => ');
        const stripeVerificationStatus = getStripeVerificationStatus(
          returnURLType,
          current_verification_attempts
        );

        const hasReachedRestrictionLimit =
          current_verification_attempts === 4 && stripeVerificationStatus === USER_TYPE_RESTRICTED;

        const data = {
          userEmail: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
          email,
          name: `${firstName} ${lastName}`,
          userName: `${firstName} ${lastName}`,
          remainingAttempts: Math.max(0, 4 - current_verification_attempts),
        };

        // const sendGridMailData = {
        //   data,
        //   template_id: hasReachedRestrictionLimit
        //     ? STRIPE_VERIFICATION_LIMIT_REACHED_TEMPLATE_ID
        //     : stripeVerificationStatus === USER_TYPE_VERIFIED
        //     ? STRIPE_VERIFICATION_ACCEPTED_TEMPLATE_ID
        //     : STRIPE_VERIFICATION_DENIED_TEMPLATE_ID,
        // };

        // onSingleMailApiCollection(sendGridMailData);

        // if (hasReachedRestrictionLimit) {
        //   // send email to admin when user reaches restriction limit
        //   onSingleMailApiCollection({
        //     data: {
        //       name: process.env.REACT_APP_SENDGRID_SENDER_NAME,
        //       email: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
        //       userEmail: email,
        //       userName: `${firstName} ${lastName}`,
        //       userID: id?.uuid,
        //     },
        //     template_id: STRIPE_VERIFICATION_LIMIT_REACHED_ADMIN_TEMPLATE_ID,
        //   });
        // }

        updateUserApi({
          userId: id?.uuid,
          payload: {
            metadata: {
              id_verification_status: stripeVerificationStatus,
              verification_attempts: current_verification_attempts,
              ...(manual_override_reason === null ? { manual_override_reason: '' } : {}),
            },
          },
        }).then(res => {
          const entities = denormalisedResponseEntities(res);
          if (entities.length !== 1) {
            throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
          }
          const currentUser = entities[0];

          // Update current user in state.user.currentUser through user.duck.js
          dispatch(currentUserShowSuccess(currentUser));
          // Update Algolia with stripe connected status 
          const stripeConnected = stripeVerificationStatus == "verified" ? true : false;
          dispatch(updateUserInAlgolia(currentUser?.id?.uuid, { stripeConnected }));
          
          // Update stripe data in mongo db
          updateUserStripeConnectionApi({
            userId: currentUser?.id?.uuid,
            stripeConnected,
          }).catch(err => console.error('Failed to update stripe connection in MongoDB:', err));

        });

        console.log('&&& USER Verify Badge Added &&& => ');
      }
    }
    return response;
  });
};
